// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".break-word[data-v-5b876757]{word-wrap:break-word}.trust-item[data-v-5b876757]{min-width:80px;text-align:center}.trust-subline[data-v-5b876757]{font-size:12px}img[data-v-5b876757]{display:inline-block;width:48px;height:auto}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
